import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.jsx';
import { Loading } from './components/ui.jsx';
import { useAuth } from './lib/auth.jsx';
import { t } from './lib/i18n.js';

import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import PurchaseList from './pages/PurchaseList.jsx';
import PurchaseForm from './pages/PurchaseForm.jsx';
import PurchaseReceipt from './pages/PurchaseReceipt.jsx';
import SaleList from './pages/SaleList.jsx';
import SaleForm from './pages/SaleForm.jsx';
import SaleReceipt from './pages/SaleReceipt.jsx';
import Parties from './pages/Parties.jsx';
import Statement from './pages/Statement.jsx';
import Tanks from './pages/Tanks.jsx';
import Expenses from './pages/Expenses.jsx';
import Payroll from './pages/Payroll.jsx';
import Reports from './pages/Reports.jsx';
import Settings from './pages/Settings.jsx';
import Backup from './pages/Backup.jsx';
import Queue from './pages/Queue.jsx';
import Exchange from './pages/Exchange.jsx';
import ExchangeStatement from './pages/ExchangeStatement.jsx';
import Shareholders from './pages/Shareholders.jsx';
import ShareholderStatement from './pages/ShareholderStatement.jsx';

export default function App() {
  const { status } = useAuth();

  if (status === 'checking') return <Loading label={t.app.opening} />;
  if (status === 'signed-out') {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />

        <Route path="buy" element={<PurchaseList />} />
        <Route path="buy/new" element={<PurchaseForm />} />
        <Route path="buy/:id/edit" element={<PurchaseForm />} />
        <Route path="buy/:id/receipt" element={<PurchaseReceipt />} />

        <Route path="sell" element={<SaleList />} />
        <Route path="sell/new" element={<SaleForm />} />
        <Route path="sell/:id/edit" element={<SaleForm />} />
        <Route path="sell/:id/receipt" element={<SaleReceipt />} />

        <Route path="customers" element={<Parties type="customer" />} />
        <Route path="customers/:id" element={<Statement type="customer" />} />
        <Route path="suppliers" element={<Parties type="supplier" />} />
        <Route path="suppliers/:id" element={<Statement type="supplier" />} />

        <Route path="tanks" element={<Tanks />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="exchange" element={<Exchange />} />
        <Route path="exchange/:id" element={<ExchangeStatement />} />
        <Route path="shareholders" element={<Shareholders />} />
        <Route path="shareholders/:id" element={<ShareholderStatement />} />
        <Route path="backup" element={<Backup />} />
        <Route path="queue" element={<Queue />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
